var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebinars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "webinars"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27797",
    "data-name": "Rectangle 27797",
    width: 16,
    height: 16,
    transform: "translate(26 357)",
    fill: "#8391a2",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_610",
    "data-name": "Mask Group 610",
    transform: "translate(-26 -357)",
    clipPath: "url(#webinars)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_62_",
    "data-name": "svgexport-6 (62)",
    transform: "translate(26 357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11318",
    "data-name": "Group 11318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11419",
    "data-name": "Path 11419",
    d: "M14.719,12.04V10.5a1.383,1.383,0,0,0-.543-1.072l-.024-.018a1.467,1.467,0,0,0-.683-2.3v-5.7A1.408,1.408,0,0,0,12.063,0H3.938A1.408,1.408,0,0,0,2.531,1.406v5.7a1.467,1.467,0,0,0-.683,2.3,1.382,1.382,0,0,0-.568,1.09v1.54a1.408,1.408,0,0,0-1.25,1.4v1.156A1.408,1.408,0,0,0,1.438,16H14.563a1.408,1.408,0,0,0,1.406-1.406V13.438A1.408,1.408,0,0,0,14.719,12.04Zm-5-.009V10.5a1.383,1.383,0,0,0-.543-1.072L9.152,9.41a1.467,1.467,0,0,0,.24-.441h2.217a1.467,1.467,0,0,0,.24.442,1.382,1.382,0,0,0-.568,1.09v1.531Zm-5,0V10.5a1.383,1.383,0,0,0-.543-1.072L4.152,9.41a1.467,1.467,0,0,0,.24-.441H6.608a1.467,1.467,0,0,0,.24.442,1.382,1.382,0,0,0-.568,1.09v1.531ZM2.219,10.5c0-.283.365-.531.781-.531a.957.957,0,0,1,.59.191.462.462,0,0,1,.191.34v1.531H2.219ZM8,9.031A.531.531,0,1,1,8.531,8.5.532.532,0,0,1,8,9.031ZM7.219,10.5c0-.283.365-.531.781-.531a.957.957,0,0,1,.59.191.462.462,0,0,1,.191.34v1.531H7.219Zm5,0c0-.283.365-.531.781-.531a.957.957,0,0,1,.59.191.462.462,0,0,1,.191.34v1.531H12.219ZM13,9.031a.531.531,0,1,1,.531-.531A.532.532,0,0,1,13,9.031ZM3.938.938h8.125a.469.469,0,0,1,.469.469v5.7a1.475,1.475,0,0,0-.923.923H9.392a1.468,1.468,0,0,0-2.783,0H4.392a1.475,1.475,0,0,0-.923-.923v-5.7A.469.469,0,0,1,3.938.938ZM2.469,8.5A.531.531,0,1,1,3,9.031.532.532,0,0,1,2.469,8.5Zm12.563,6.094a.469.469,0,0,1-.469.469H1.438a.469.469,0,0,1-.469-.469V13.438a.469.469,0,0,1,.469-.469H14.563a.469.469,0,0,1,.469.469Z",
    fill: "#8391a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11420",
    "data-name": "Path 11420",
    d: "M7.084,6.059a.771.771,0,0,0,.8-.045l1.751-1.2a.772.772,0,0,0,0-1.273h0L7.884,2.333a.772.772,0,0,0-1.212.635V5.376a.77.77,0,0,0,.412.683ZM7.61,3.283l1.295.9L7.61,5.063Z",
    fill: "#8391a2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinars);
export default __webpack_public_path__ + "static/media/webinars.492bbec0c12b8fa41cb761973bb3cdaf.svg";
export { ForwardRef as ReactComponent };